import { fetch } from '@atlassian/eoc-fetch';
import { UrlHelper } from '../../../common/utils/url-helper';
export const getUserRights = teamId => {
  return fetch(UrlHelper(`/v1/entity-sync/unified/rights`, {
    teamId
  })).then(response => response.data.userAccessRights);
};